import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import AsSelectWithPlaceholder from '../generic/AsSelectWithPlaceholder';
import { AsButton } from '@adserve/adserve-react-components';

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1040,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)'
};

const wrapperStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1050,
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    outline: 0
};

export const rowStyle = {
    display: 'flex',
    marginTop: '5%'
};

const buttonStyle = {
    fontSize: 16,
    width: 120
};

export const headingStyle = {
    fontFamily: 'roboto',
    fontSize: 20,
    fontWeight: 'bold'
};

const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    boxSizing: 'border-box',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    padding: '24px 23px 40px',
    borderRadius: 15,
    backgroundColor: '#FFFFFF',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)',
    fontFamily: 'Roboto',
    fontSize: 22,
    fontWeight: 500,
    wordBreak: 'break-word',
};

const CancelCampaignModal = ({ isShowing, workflowTeams, onClose, onDoCancel }) => {
    const [selectedApprovalTeam, setSelectedApprovalTeam] = useState('-1');

    const handleApprovalTeamChange = (e) => {
        setSelectedApprovalTeam(e.target.value);
    };

    const handleClose = () => {
        typeof onClose === 'function' && onClose(false);
        setSelectedApprovalTeam('-1');
    }

    const handleCancel = () => {
        typeof onDoCancel === 'function' && onDoCancel(selectedApprovalTeam);
        setSelectedApprovalTeam('-1');
    };

    return isShowing
        ? ReactDOM.createPortal(
            <>
                <div style={overlayStyle} />
                <div style={wrapperStyle} tabIndex={-1} role='dialog'>
                    <div style={bodyStyle}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <span style={headingStyle}>{window.translate('Select the team to send the cancellation to')}</span>
                        </div>
                        <div style={rowStyle}>
                            <AsSelectWithPlaceholder
                                id='campaign-approval-team'
                                name='campaignApprovalTeamId'
                                values={workflowTeams}
                                value={selectedApprovalTeam}
                                onChange={handleApprovalTeamChange}
                                title={window.translate('Cancel Approval Team')}
                            />
                        </div>
                        <div style={{ ...rowStyle, justifyContent: 'space-between' }}>
                            <AsButton
                                useTertiaryStyle
                                style={buttonStyle}
                                handleClick={handleClose}
                            >
                                {window.translate('Close')}
                            </AsButton>
                            <AsButton
                                style={{ ...buttonStyle, marginLeft: 20 }}
                                handleClick={handleCancel}
                                disabled={selectedApprovalTeam === '-1'}
                            >
                                {window.translate('Cancel Campaign')}
                            </AsButton>
                        </div>
                    </div>
                </div>
            </>,
            document.body
        )
        : null;
}

export default CancelCampaignModal;
